import { render } from "./UtentiTable.vue?vue&type=template&id=096c0930&scoped=true"
import script from "./UtentiTable.vue?vue&type=script&lang=js"
export * from "./UtentiTable.vue?vue&type=script&lang=js"

import "./UtentiTable.vue?vue&type=style&index=0&id=096c0930&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-096c0930"]])

export default __exports__